/**
 * "Home" (fix N, 2026-10-06 — renamed from "Lobby"): the owner's ask was a way
 * back to the lobby FROM THE MOVE-LIST RAIL, without hunting for the drawer
 * (fix D / R2), and fix N makes it go all the way home: `goToLobby`
 * (`../useGameActions`) now leaves an open tournament too (`leaveTournament`),
 * so this tile also lands on the home page's Tournaments tab instead of the
 * tournament's own idle view.
 *
 * It is enabled the moment nothing is still being played: a finished game of
 * mine, a finished watch, a replay, or no game at all. While a live game or a
 * live watch is on it is disabled and says which one is in the way.
 *
 * ONE `useShallow` selector (`selectActionGate`), which is the same object the
 * Analysis tile reads — the fair-play rule has one source.
 */
import {useShallow} from 'zustand/react/shallow';

import {useLiveGame} from '@/Store/liveGameStore';

import {goToLobby} from '../useGameActions';
import {selectActionGate, settled} from '../gates';

export type LobbyActionModel = {
  /** the tile's own label: the action, or the short reason it is off */
  label: string;
  /** the full sentence (the a11y name; RNW cannot draw a title tooltip) */
  hint: string;
  disabled: boolean;
  onPress: () => void;
};

export function useLobbyActionModel(): LobbyActionModel {
  const gate = useLiveGame(useShallow(selectActionGate));
  const disabled = !settled(gate);

  return {
    label: disabled ? (gate.liveWatch ? 'Watching' : 'In game') : 'Home',
    hint: gate.liveWatch
      ? 'Stop watching first'
      : gate.liveGame
      ? 'Finish the game first'
      : 'Back to home',
    disabled,
    onPress: goToLobby,
  };
}

export default useLobbyActionModel;
